import React from 'react';

export const ArbitalLogo = ({className, strokeWidth, color}: {
  className?: string
  strokeWidth?: number
  color?: string
}) => {
  // Common props for all paths
  const pathProps = {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth,
    color
  };

  return (
    <svg className={className} x="0px" y="0px" height="100%" viewBox="0 0 27.5 23.333">
      <g>
        <path 
          d="M19.166,20.979v-0.772c-1.035,0.404-2.159,0.626-3.334,0.626c-0.789,0-1.559-0.1-2.291-0.288
          c-0.813-0.21-1.584-0.529-2.292-0.94c-0.032-0.019-0.06-0.042-0.091-0.061c-2.686-1.596-4.49-4.525-4.492-7.877
          c0.001-3.027,1.471-5.713,3.733-7.381c-0.229,0.04-0.458,0.079-0.679,0.139C9.68,4.435,9.643,4.449,9.604,4.461
          C9.359,4.53,9.123,4.613,8.891,4.706c-0.07,0.028-0.14,0.057-0.209,0.086C8.42,4.906,8.164,5.029,7.918,5.172
          c-2.243,1.299-3.752,3.717-3.752,6.494c0,2.99,1.123,5.711,2.973,7.777c0.285,0.319,0.594,0.625,0.918,0.915
          c1.123,1.005,2.44,1.797,3.888,2.309c0.626,0.223,1.272,0.39,1.944,0.503c0.632,0.105,1.281,0.162,1.943,0.162
          c1.159,0,2.277-0.17,3.334-0.484V20.979z"
          {...pathProps}
        />
        <path 
          d="M19.443,2.975c-1.123-1.007-2.441-1.799-3.889-2.311c-0.623-0.221-1.273-0.391-1.943-0.502
          C12.979,0.056,12.33,0,11.666,0c-1.365,0-2.671,0.233-3.889,0.664C6.33,1.176,5.012,1.966,3.889,2.971
          C1.5,5.11,0.001,8.208,0,11.666c0.001,3.457,1.5,6.557,3.889,8.695c1.123,1.004,2.441,1.794,3.889,2.306
          c0.32,0.113,0.646,0.213,0.979,0.298c-0.186-0.116-0.361-0.248-0.541-0.373c-0.108-0.075-0.219-0.146-0.324-0.224
          c-0.327-0.243-0.645-0.498-0.947-0.77c-0.363-0.327-0.715-0.674-1.047-1.044C3.785,18.198,2.5,15.078,2.5,11.666
          c0-3.393,1.846-6.355,4.582-7.937c1.35-0.78,2.916-1.231,4.584-1.231c0.789,0,1.559,0.102,2.292,0.291
          c0.813,0.209,1.584,0.529,2.292,0.938c2.738,1.583,4.582,4.546,4.584,7.938c-0.002,3.027-1.473,5.713-3.736,7.381
          c-0.007,0.005-0.013,0.011-0.02,0.016c0.237-0.039,0.471-0.092,0.699-0.154c0.042-0.011,0.082-0.026,0.124-0.038
          c0.24-0.069,0.475-0.151,0.704-0.242c0.072-0.029,0.144-0.058,0.215-0.089c0.261-0.113,0.517-0.236,0.761-0.378l1.251-0.725v2.562
          v0.98v2.354h2.5v-2.351v-0.984v-8.332c0-2.992-1.123-5.712-2.971-7.777C20.074,3.568,19.767,3.265,19.443,2.975z"
          {...pathProps}
        />
        <path 
          d="M23.609,2.971c-1.123-1.005-2.44-1.795-3.888-2.307C19.4,0.551,19.073,0.451,18.74,0.365
          c0.186,0.116,0.36,0.246,0.539,0.371c0.109,0.076,0.223,0.148,0.33,0.228c0.326,0.243,0.643,0.497,0.945,0.769
          c0.365,0.327,0.716,0.674,1.049,1.043c2.109,2.357,3.396,5.479,3.396,8.891v8.332v0.984v2.35H27.5V11.666
          C27.498,8.208,25.999,5.11,23.609,2.971z"
          {...pathProps}
        />
      </g>
    </svg>
  );
};
